import { useMemo } from 'react';
import { CopyButton } from '../common/CopyButton';
import { JsonViewer } from './JsonViewer';

interface HeadersTableProps {
  data: string | null;
}

export function HeadersTable({ data }: HeadersTableProps) {
  const parsed = useMemo(() => {
    if (!data || data === 'null') return null;
    try {
      const obj = JSON.parse(data);
      if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) return 'invalid';
      return obj as Record<string, string>;
    } catch {
      return 'invalid';
    }
  }, [data]);

  if (parsed === null) {
    return <p className="text-sm text-base-content/70">No headers</p>;
  }

  if (parsed === 'invalid') {
    return <JsonViewer data={data!} />;
  }

  const entries = Object.entries(parsed);
  if (entries.length === 0) {
    return <p className="text-sm text-base-content/70">No headers</p>;
  }

  return (
    <div className="bg-base-200 border border-base-300 rounded-box overflow-x-auto">
      <table className="w-full">
        <tbody>
          {entries.map(([key, value]) => (
            <tr key={key} className="group">
              <td className="py-1 pl-3 pr-2 font-mono text-xs font-semibold text-base-content/70 whitespace-nowrap align-top">
                {key}
              </td>
              <td className="py-1 px-2 font-mono text-xs text-base-content break-all align-top">
                {String(value)}
              </td>
              <td className="py-0.5 pr-1 w-6 align-top">
                <CopyButton
                  text={`${key}: ${value}`}
                  iconOnly
                  className="btn-xs opacity-0 group-hover:opacity-100 transition-opacity !h-5 !min-h-0 !w-5 !p-0 [&_svg]:w-3 [&_svg]:h-3"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
